/**
 * Validates if a string is valid JSON
 * @param jsonString - The string to validate
 * @returns Object with isValid boolean and error message if invalid
 */
export function validateJSON(jsonString: string): { isValid: boolean; error?: string } {
  if (!jsonString || jsonString.trim() === '') {
    return { isValid: true } // Empty is valid
  }

  try {
    JSON.parse(jsonString)
    return { isValid: true }
  } catch (error) {
    return {
      isValid: false,
      error: error instanceof Error ? error.message : 'Invalid JSON format'
    }
  }
}

/**
 * Formats JSON string for display with proper indentation
 * @param jsonString - The JSON string to format
 * @returns Formatted JSON string or original string if invalid
 */
export function formatJSON(jsonString: string): string {
  if (!jsonString || jsonString.trim() === '') {
    return jsonString
  }

  try {
    const parsed = JSON.parse(jsonString)
    return JSON.stringify(parsed, null, 2)
  } catch (error) {
    console.log(error)
    return jsonString
  }
}
